import { trackError } from 'utils/helpers';

const setWeather = (weather, el) => {
  el.innerHTML = `${Math.round(weather)}&deg;`;
};

const init = () => {
  const el = document.querySelector('[data-weather-location]');

  if (el) {
    fetch(
      `https://api.openweathermap.org/data/2.5/weather?q=${el.dataset.weatherLocation}&appid=21e308dde86e8a0cccc2dea9108b431b&units=metric`
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(`Request rejected with status ${response.status}`);
      })
      .then((data) => {
        setWeather(data.main.temp, el);
      })
      .catch((error) => {
        trackError(error);
        el.remove();
      });
  }
};

document.addEventListener('DOMContentLoaded', init);
